"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminTable = void 0;
const mithril_1 = __importDefault(require("mithril"));
const admin_1 = require("../../../model/admin");
const confirm_1 = require("../../../utils/confirm");
const helpers_1 = require("../../../utils/helpers");
const table_renderers_1 = require("../../../utils/table_renderers");
const notification_center_1 = require("../../../widgets/notification_center");
const table_1 = require("../../../widgets/table");
const admin_form_1 = require("./admin_form");
function editUser(id) {
    admin_form_1.AdminForm.show({ id: id });
}
function deleteUser(id) {
    confirm_1.Confirm.confirm("Etes-vous sûr de vouloir faire ça?").then(() => {
        admin_1.AdminProvider.delete(id).catch((e) => {
            notification_center_1.Notification.error(e.infos || e.message);
            admin_1.AdminProvider.clearError();
        });
    });
}
exports.AdminTable = (0, table_1.createTable)({
    id: "adminTable",
    fields: [
        {
            name: "id",
            sortable: true,
            label: "n°"
        },
        {
            name: "first_name",
            sortable: true,
            label: "Prénom"
        },
        {
            name: "last_name",
            sortable: true,
            label: "Nom"
        },
        {
            name: "email",
            sortable: true,
            label: "Email"
        },
        {
            name: "role",
            sortable: true,
            label: "Role",
            renderer: table_renderers_1.TableRenderers.tag(x => x.role)
        }
    ],
    provider: admin_1.AdminProvider,
    filters: [],
    title: "Administrateurs",
    topMenuRight: () => {
        return (0, mithril_1.default)("a", { class: "button is-success", onclick: () => { admin_form_1.AdminForm.active = true; } }, (0, helpers_1.iconSpan)("fa-user-plus", "is-small"), (0, mithril_1.default)("span", "Nouvel Administrateur"));
    },
    actions: (mdl) => {
        let out = [];
        out.push((0, mithril_1.default)("button.button.is-primary", { onclick: () => { editUser(mdl.id); } }, (0, helpers_1.iconSpan)("fa-pen"), (0, mithril_1.default)("span", "Éditer")));
        out.push((0, mithril_1.default)("button.button.is-danger", { onclick: () => { deleteUser(mdl.id); } }, (0, helpers_1.iconSpan)("fa-times"), (0, mithril_1.default)("span", "Supprimer")));
        return (0, helpers_1.buttonGroup)(...out);
    },
});
